import { createContext, useContext, useMemo, type ReactNode } from "react";

export type FoodFormUiVariant = "legacy" | "redesign";

interface FoodFormUiContextValue {
  variant: FoodFormUiVariant;
}

const FoodFormUiContext = createContext<FoodFormUiContextValue>({
  variant: "legacy",
});

interface FoodFormUiProviderProps {
  variant: FoodFormUiVariant;
  children: ReactNode;
}

/** Shared by Recipe and Menu Item forms behind `isRecipeAndMenuItemRedesignEnabled`. */
export const FoodFormUiProvider = ({ variant, children }: FoodFormUiProviderProps) => {
  const value = useMemo((): FoodFormUiContextValue => ({ variant }), [variant]);
  return <FoodFormUiContext.Provider value={value}>{children}</FoodFormUiContext.Provider>;
};

export const useFoodFormUi = (): FoodFormUiContextValue => useContext(FoodFormUiContext);

export const useIsFoodFormRedesign = (): boolean => useFoodFormUi().variant === "redesign";
